/* eslint complexity: "off" */
/* global require */
export function get(viewClass) {
    switch (viewClass) {
        case 'administration-newsList':
            return new Promise(resolve => {
                require.ensure(['./administration/news/NewsListController'], () => resolve({
                    Controller: require('./administration/news/NewsListController').default
                }));
            });

        case 'administration-contentViews-contentView':
            return new Promise(resolve => {
                require.ensure(['./administration/views/ContentViewController'], () => resolve({
                    Controller: require('./administration/views/ContentViewController').default
                }));
            });

        case 'administration-shippingAddressFieldGroups-shippingAddressFieldGroup':
            return new Promise(resolve => {
                require.ensure(['./administration/shippingAddressFieldGroups/ShippingAddressFieldGroupController'], () => resolve({
                    Controller: require('./administration/shippingAddressFieldGroups/ShippingAddressFieldGroupController').default
                }));
            });

        case 'administration-news-news':
            return new Promise(resolve => {
                require.ensure(['./administration/news/NewsController'], () => resolve({
                    Controller: require('./administration/news/NewsController').default
                }));
            });

        case 'administration-buckets-buckets':
            return new Promise(resolve => {
                require.ensure(['./administration/buckets/BucketsController'], () => resolve({
                    Controller: require('./administration/buckets/BucketsController').default
                }));
            });

        case 'administration-catalogs-catalogs':
            return new Promise(resolve => {
                require.ensure(['./administration/catalogs/CatalogsController'], () => resolve({
                    Controller: require('./administration/catalogs/CatalogsController').default
                }));
            });

        case 'administration-catalogs-editCatalogItem':
            return new Promise(resolve => {
                require.ensure(['./administration/catalogs/EditCatalogItemController'], () => resolve({
                    Controller: require('./administration/catalogs/EditCatalogItemController').default
                }));
            });

        case 'administration-themes-theme':
            return new Promise(resolve => {
                require.ensure(['./administration/themes/ThemeController'], () => resolve({
                    Controller: require('./administration/themes/ThemeController').default
                }));
            });

        case 'administration-themes-themes':
            return new Promise(resolve => {
                require.ensure(['./administration/themes/ThemesController'], () => resolve({
                    Controller: require('./administration/themes/ThemesController').default
                }));
            });

        case 'administration-imports-imports':
            return new Promise(resolve => {
                require.ensure(['./administration/imports/ImportsController'], () => resolve({
                    Controller: require('./administration/imports/ImportsController').default
                }));
            });

        case 'administration-imports-import':
            return new Promise(resolve => {
                require.ensure([
                    './administration/imports/ImportController',
                    './administration/imports/ImportRouter.js'
                ], () => resolve({
                    Controller: require('./administration/imports/ImportController').default,
                    Router: require('./administration/imports/ImportRouter').default
                }));
            });

        case 'administration-upload-media':
            return new Promise(resolve => {
                require.ensure(['./administration/mediaUpload/MediaUploadController'], () => resolve({
                    Controller: require('./administration/mediaUpload/MediaUploadController').default
                }));
            });

        case 'administration-article-sync':
            return new Promise(resolve => {
                require.ensure(['./administration/articleSync/ArticleSyncController'], () => resolve({
                    Controller: require('./administration/articleSync/ArticleSyncController').default
                }));
            });

        case 'administration-portalCustomers-portalCustomer':
            return new Promise(resolve => {
                require.ensure(['./administration/portalCustomers/PortalCustomerController'], () => resolve({
                    Controller: require('./administration/portalCustomers/PortalCustomerController').default
                }));
            });

        case 'administration-portalCustomers-portalCustomers':
            return new Promise(resolve => {
                require.ensure(['./administration/portalCustomers/PortalCustomersController'], () => resolve({
                    Controller: require('./administration/portalCustomers/PortalCustomersController').default
                }));
            });

        case 'administration-users-users':
            return new Promise(resolve => {
                require.ensure(['./administration/users/UsersController'], () => resolve({
                    Controller: require('./administration/users/UsersController').default
                }));
            });

        case 'administration-users-user':
            return new Promise(resolve => {
                require.ensure(['./administration/users/UserController'], () => resolve({
                    Controller: require('./administration/users/UserController').default
                }));
            });

        case 'administration-priceCondition-priceCondition':
            return new Promise(resolve => {
                require.ensure(['./administration/priceCondition/PriceConditionController'], () => resolve({
                    Controller: require('./administration/priceCondition/PriceConditionController').default
                }));
            });

        case 'administration-punchoutCatalogs-punchoutCatalog':
            return new Promise(resolve => {
                require.ensure(['./administration/punchoutCatalogs/PunchoutCatalogController'], () => resolve({
                    Controller: require('./administration/punchoutCatalogs/PunchoutCatalogController').default
                }));
            });

        case 'administration-punchoutCatalogs-punchoutCatalogs':
            return new Promise(resolve => {
                require.ensure(['./administration/punchoutCatalogs/PunchoutCatalogsController'], () => resolve({
                    Controller: require('./administration/punchoutCatalogs/PunchoutCatalogsController').default
                }));
            });

        case 'catalog-catalogItem':
            return new Promise(resolve => {
                require.ensure(['./catalog/CatalogItemController', './catalog/CatalogItemRouter'], () => resolve({
                    Controller: require('./catalog/CatalogItemController').default,
                    Router: require('./catalog/CatalogItemRouter').default
                }));
            });

        case 'catalog-catalogItems':
            return new Promise(resolve => {
                require.ensure(['./catalog/CatalogItemsController'], () => resolve({
                    Controller: require('./catalog/CatalogItemsController').default
                }));
            });

        case 'catalog-category':
            return new Promise(resolve => {
                require.ensure(['./catalog/CategoryController'], () => resolve({
                    Controller: require('./catalog/CategoryController').default
                }));
            });

        case 'catalog-productComparisonList':
            return new Promise(resolve => {
                require.ensure(['./catalog/ProductComparisonListController'], () => resolve({
                    Controller: require('./catalog/ProductComparisonListController').default
                }));
            });

        case 'homepage-index':
            return new Promise(resolve => {
                require.ensure(['./homepage/IndexController', './homepage/IndexRouter'], () => resolve({
                    Controller: require('./homepage/IndexController').default,
                    Router: require('./homepage/IndexRouter').default
                }));
            });

        case 'login-login':
            return new Promise(resolve => {
                require.ensure(['./login/LoginController'], () => resolve({
                    Controller: require('./login/LoginController').default
                }));
            });

        case 'setPassword-setPassword':
            return new Promise(resolve => {
                require.ensure(['./setPassword/SetPasswordController'], () => resolve({
                    Controller: require('./setPassword/SetPasswordController').default
                }));
            });

        case 'unlockAccount-unlockAccount':
            return new Promise(resolve => {
                require.ensure(['./unlockAccount/UnlockAccountController'], () => resolve({
                    Controller: require('./unlockAccount/UnlockAccountController').default
                }));
            });

        case 'myAccount-myAccount':
            return new Promise(resolve => {
                require.ensure(['./myAccount/MyAccountController', './myAccount/MyAccountRouter'], () => resolve({
                    Controller: require('./myAccount/MyAccountController').default,
                    Router: require('./myAccount/MyAccountRouter').default
                }));
            });

        case 'shoppingCart-orderedShoppingCartItem':
            return new Promise(resolve => {
                require.ensure([
                    './shoppingCart/OrderedShoppingCartItemController',
                    './shoppingCart/OrderedShoppingCartItemRouter'
                ], () => resolve({
                    Controller: require('./shoppingCart/OrderedShoppingCartItemController').default,
                    Router: require('./shoppingCart/OrderedShoppingCartItemRouter').default
                }));
            });

        case 'shoppingCart-shoppingCart':
            return new Promise(resolve => {
                require.ensure(['./shoppingCart/ShoppingCartController'], () => resolve({
                    Controller: require('./shoppingCart/ShoppingCartController').default
                }));
            });

        case 'shoppingCarts-shoppingCarts':
            return new Promise(resolve => {
                require.ensure(['./shoppingCart/ShoppingCartsController'], () => resolve({
                    Controller: require('./shoppingCart/ShoppingCartsController').default
                }));
            });

        case 'shoppingCart-shoppingCartItemConfirmation':
            return new Promise(resolve => {
                require.ensure(['./shoppingCart/ShoppingCartItemConfirmationController'], () => resolve({
                    Controller: require('./shoppingCart/ShoppingCartItemConfirmationController').default
                }));
            });

        case 'shoppingCart-unorderedShoppingCartItem':
            return new Promise(resolve => {
                require.ensure([
                    './shoppingCart/UnorderedShoppingCartItemController',
                    './shoppingCart/UnorderedShoppingCartItemRouter'
                ], () => resolve({
                    Controller: require('./shoppingCart/UnorderedShoppingCartItemController').default,
                    Router: require('./shoppingCart/UnorderedShoppingCartItemRouter').default
                }));
            });

        case 'savedShoppingCarts-savedShoppingCarts':
            return new Promise(resolve => {
                require.ensure(['./shoppingCart/SavedShoppingCartsController'], () => resolve({
                    Controller: require('./shoppingCart/SavedShoppingCartsController').default
                }));
            });

        case 'transferred-view':
            return new Promise(resolve => {
                require.ensure(['./transferredShoppingCarts/TransferredShoppingCartsViewController'], () => resolve({
                    Controller: require('./transferredShoppingCarts/TransferredShoppingCartsViewController').default
                }));
            });

        case 'cisco-quote-view':
            return new Promise(resolve => {
                require.ensure(['./quote/QuoteController'], () => resolve({
                    Controller: require('./quote/QuoteController').default
                }));
            });

        case 'transferredShoppingCart-transferredShoppingCarts':
            return new Promise(resolve => {
                require.ensure(['./transferredShoppingCartList/TransferredShoppingCartListController'], () => resolve({
                    Controller: require('./transferredShoppingCartList/TransferredShoppingCartListController').default
                }));
            });

        default:
            return Promise.resolve({});
    }
}



// WEBPACK FOOTER //
// ./views/Views.js